<template>
  <div>
    <div class="filters">
      <tl-select
        label="From"
        :value="filter.from"
        :options="departmentOptions"
        @change="(val)=>department = val"
      />
      <tl-select
        label="To"
        :value="filter.to"
        :options="costCentreOptions"
        @change="(val)=>costCentre = val"
      />
    </div>
    <div class="filters margin-t-15px">
      <tl-select
        label="PayGroup"
        labelText="name"
        :options="payGroupData[le_id]"
        @change="(val)=>filterData.paygroupId = val.id"
      />
      <tl-select
        label="Criteria"
        labelText="name"
        :options="criteriaList"
        @change="changesubCriteria($event)"
      />
      <tl-select label="SubCriteria" :options="SubCriteriaList" @change="(val)=>applyTo = val" />
      <tl-select label="Status" :options="statusList" @change="(val)=>applyTo = val" />
    </div>
    <button class="filter-button margin-t-15px" @click="applyFilter">Apply Filter</button>
    <tl-search class="margin-tb-25px" @change="searchData"></tl-search>
    <data-table
      :columns="columnNames"
      :tableData="employeeData"
      :checkbox="false"
      :search="searchText"
      :showinrow="false"
      :with-form="false"
    >
      <template v-slot:rowcontent="slotprops">
        <p
          v-if="slotprops.value.column.key!='action'"
        >{{slotprops.value.record[slotprops.value.column.key]}}</p>
        <!-- dropdown section starts here -->
        <div class="action-section" v-if="slotprops.value.column.key=='action'">
          <img
            src="@/assets/group-2.png"
            class="pointer-cursor"
            @click="dropdown(slotprops.value.record)"
            alt="actionIcon"
          />
          <ul class="action-menu" v-show="employeeData[slotprops.value.index].showDropDown">
            <li>
              <span class @click="reviseseSalary(slotprops.value.record)">Release Salary</span>
            </li>
            <li>
              <span class @click="RevokeReviseSalary(slotprops.value.record)">Revoke Salary</span>
            </li>
          </ul>
        </div>
      </template>
    </data-table>
    <bottom-action-container>
      <btn-grp slot="end">
        <btn text="Back" type="primary" @click="back" />
      </btn-grp>
    </bottom-action-container>
  </div>
</template>

<script>
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  // name: "Revision Salary",
  components: {
    SearchDropdown
  },
  computed: {
    computed: {}
  },
  data() {
    return {
      department: "",
      designation: "",
      costCentre: "",
      filter: {
        from: "",
        to: ""
      },
      searchText: "",
      criteriaList: ["Designation", "Grades", "Bands", "Location"],
      SubCriteriaList: [],
      statusList: ["Active", "Scheduled", "Completed", "Revoked"],
      departmentOptions: [],
      designationOptions: [],
      costCentreOptions: [],
      showHistoryPopup: false,
      revisionType: "Select",
      revisionTypeOptions: ["CTC", "Fixed Non CTC"],
      columnNames: [
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Base CTC",
          key: "baseCtc"
        },
        {
          label: "Revised CTC",
          key: "revisedCtc"
        },
        {
          label: "Effective Date",
          key: "effDate"
        },
        {
          label: "Status",
          key: "status"
        },
        {
          label: "Total Revision 8888",
          key: "totRev"
        }
      ],
      employeeData: [],
      historyDataCols: [
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Current Salary",
          key: "currentSalary"
        },
        {
          label: "Scheduled Revision",
          key: "scheduledRevision"
        }
      ],
      historyData: [
        {
          code: "CTC",
          currentSalary: "Rs. 140000",
          scheduledRevision: "Rs. 145000"
        },
        {
          code: "Gross Salary",
          currentSalary: "Rs. 120000",
          scheduledRevision: "Rs. 130000"
        },
        {
          code: "Basic",
          currentSalary: "Rs. 150000",
          scheduledRevision: "Rs. 150000"
        },
        {
          code: "Provident Fund",
          currentSalary: "Rs. 65000",
          scheduledRevision: "3,45,688.80"
        },
        {
          code: "Special Allowance",
          currentSalary: "Rs. 45000",
          scheduledRevision: "Rs. 122990"
        },
        {
          code: "Meal Voucher",
          currentSalary: "Rs. 30000",
          scheduledRevision: "2,85,958.00"
        }
      ],
      initialData: [
        {
          code: "CTC",
          currentSalary: "Rs. 140000",
          scheduledRevision: "Rs. 145000"
        }
      ],
      fixedNonCtcColumnNames: [
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Previous Amount",
          key: "prevAmt"
        },
        {
          label: "Revised Amount",
          key: "revisedAmt"
        },
        {
          label: "Effective Date",
          key: "effDate"
        }
      ],
      fixedNonCtcData: []
    };
  },
  activated() {
    this.fetchAll();
  },
  computed: {
    ...mapState({
      reviseSalaryData: state => state.dashboard.revisesalary.revisesalary,
      employeesJoiningsData: state => state.dashboard.joinings.joinings, //fetch employees data
      payGroupData: state => state.onboard.paygroup.data,
      designationList: state => state.onboard.designations.entityWiseData,
      gradeList: state => state.onboard.salary_grades.data,
      bandList: state => state.onboard.salary_bands.data,
      locationList: state => state.onboard.locations.data
    }),
    le_id() {
      return this.$store.getters["onboard/legal_entities/legal_entity_ID"](
        this.$route.params.entity_index
      );
    }
  },
  methods: {
    ...mapActions({
      act_fetchAll: "dashboard/payroll/utilities/revisesalary/fetchReviseSalary"
    }),
    applyFilter() {},
    back() {},
    changeRevisionType(val) {
      this.revisionType = val;
    },
    searchData(searchText) {
      this.searchText = searchText;
    },
    async fetchAll() {
      try {
        let res = await this.act_fetchAll(this.paygroupId);
        if (res.message != null) {
          throw Error(res.message);
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    async fetchEmplDetails() {
      let tempObj = {};
      try {
        let res = await this.act_fetchAllEmployees({ le_id: this.le_id });
        // this.employeeData = res.data.payload.data;
        if (res.data.payload.data.length) {
          for (let employee of res.data.payload.data) {
            (employee["name"] = employee.name),
              (employee["code"] = employee.code),
              (employee["email"] = employee.email_id),
              (employee["showDropDown"] = false);
            employee["empSalarySettings"] = employee.EmployeeSalarySetting;
            for (let salarySettingObj of employee.empSalarySettings) {
              employee["currCtc"] = salarySettingObj.ctc;
            }
          }
          this.employeeData = [...res.data.payload.data];
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    dropdown(slots) {
      try {
        let idx = this.employeeData.findIndex(obj => {
          return obj.id == slots.id;
        });
        this.employeeData.forEach((data, index) => {
          if (index !== idx) {
            data.showDropDown = false;
          }
        });
        if (idx > -1) {
          this.employeeData[idx].showDropDown = this.employeeData[idx]
            .showDropDown
            ? false
            : true;
          this.employeeData = [...this.employeeData];
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    editInput(val) {
      this.$emit("editRevisedSalary", val);
    },
    showHistory(val) {
      this.showHistoryPopup = true;
      this.$emit("showHistoryPage", val);
    },
    selectedEmp(emp) {
      try {
        this.showCtcDetailsCard = true;
        this.empName = emp.name;
        this.empId = emp.code;
        this.empMail = emp.mail;
        this.currCTC = emp.currentSalary;
        this.revisedCTC = this.editrecord.revisedSalary;
        this.effDate = this.effectiveDate;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    changesubCriteria(event) {
      try {
        switch (event) {
          case "Designation":
            this.subCriteriaList = this.designationList[this.le_id];
            break;
          case "Grades":
            this.subCriteriaList = this.gradeList[this.le_id];
            break;
          case "Bands":
            this.subCriteriaList = this.bandList[this.le_id];
            break;
          case "Location":
            this.subCriteriaList = this.locationList[this.le_id];
            break;
          default:
            this.subCriteriaList = [];
            break;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.search-container {
  display: flex;
}
.export-section {
  margin-right: 5px;
  margin-top: 5%;
  align-items: flex-start;
  display: flex;
  justify-content: flex-end;
}
.export-button {
  height: 35px;
  border-radius: 4px;
  font-family: Montserrat;
  font-size: 12px;
  text-align: center;
  border: 1px solid #5d409f;
  color: #5d409f;
  //   margin-left: 3px;
}
.filter-button {
  width: 100px;
  height: 35px;
  border-radius: 4px;
  font-family: Montserrat;
  font-size: 12px;
  text-align: center;
  border: 1px solid #34c0be;
  color: #34c0be;
}
.modal {
  display: block;
  position: fixed;
  z-index: 6;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.3);
}

/* Modal Content */
.modal-content {
  background-color: white;
  margin: 150px auto 0px auto;
  z-index: 20;
  width: 500px;
  height: 375px;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  padding: 30px 36px 36px 0px;

  .uploadMethoRadio,
  .filters {
    margin-left: 8%;
    margin-top: 2%;

    .midMargin {
      margin-left: 11.5%;
    }
  }
  .modal-btnGrp {
    justify-content: center;
  }
}
.modal-content-history {
  background-color: white;
  margin: 60px auto 0px auto;
  z-index: 20;
  width: 950px;
  //   height: 510px;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  padding: 30px 36px 36px 0px;

  .datatableClass {
    margin-left: 10%;
    margin-top: 5%;

    .dataClass {
      padding: 0px;
    }
  }
}
</style>
